import { useEffect, useState } from 'react';
import loadAnim from './loadanim.gif';
import { useLoader } from './LoaderContext';
import './Loader.css';

function Loader() {
  const { active, hideLoader } = useLoader();
  const [mounted, setMounted] = useState(true);

  useEffect(() => {
    if (document.readyState === 'complete') {
      hideLoader();
      return;
    }
    const handleLoad = () => hideLoader();
    window.addEventListener('load', handleLoad);
    return () => window.removeEventListener('load', handleLoad);
  }, [hideLoader]);

  useEffect(() => {
    if (active) {
      setMounted(true);
      return;
    }
    const timeout = setTimeout(() => setMounted(false), 600);
    return () => clearTimeout(timeout);
  }, [active]);

  if (!mounted) return null;

  return (
    <div className={`loader-container${active ? '' : ' loader-fade'}`}>
      <img className="loader-gif" src={loadAnim} alt="Loading" />
    </div>
  );
}

export default Loader;
